Vue.component('asset-actions', {
    props: ['asset'],
    template: `
        <div class="dropdown text-center" v-if="currentAsset">
            <a href="#" class="text-dark btn btn-plain wide" data-toggle="dropdown" aria-haspopup="true"
               aria-expanded="false">
                <i class="fal fa-2x fa-ellipsis-v"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenu2">
                <a :href="'/team/assets/' + currentAsset.id" class="dropdown-item" target="_blank">Preview Asset</a>
                <template v-if="currentAsset.asset_type === 'simple'">
                    <a :href="'/team/assets/' + currentAsset.id + '/edit'" class="dropdown-item">Edit Asset</a>
                </template>
                <template v-else>
                    <a :href="'/team/bundles/' + currentAsset.id + '/details'" class="dropdown-item">Edit Asset</a>
                </template>
                <a href="#" class="dropdown-item" @click.prevent="duplicateAsset">Duplicate Asset</a>
                <a href="#" v-if="!currentAsset.hidden" class="dropdown-item" @click.prevent="hideAsset">Hide Asset</a>
                <a href="#" v-if="currentAsset.hidden" class="dropdown-item" @click.prevent="hideAsset">Unhide Asset</a>
            </div>
        </div>
    `,
    data() {
        return {
            currentAsset: null,
        };
    },
    methods: {
        duplicateAsset() {
            axios.post(`/api/team/assets/${this.currentAsset.id}/duplicate`).then((response) => {
                let asset = this.$vueData.getData(response);
                window.location = '/team/assets/' + asset.id + '/edit';
            });
        },
        hideAsset() {
            const _this = this;

            if (this.currentAsset.status !== 2) {
                axios.post('/api/team/assets/' + this.currentAsset.id + '/active').then((response) => {
                    let data = _this.$vueData.getData(response);

                    if (!data.hidden) {
                        _this.$noty.success('Asset visible');
                    } else {
                        _this.$noty.success('Asset hidden');
                    }

                    Bus.$emit('assetHideToggle', _this.currentAsset);
                });
            } else {
                this.$noty.error('Unpost the asset before hiding');
            }
        },
    },
    watch: {
        asset: {
            immediate: true,
            deep: true,
            handler() {
                this.currentAsset = this.asset;
            },
        },
    },
});
